export default {
  title: 'Métodos de pedido',
  paywall: {
    live_title: '¡{{name}} ya está en línea!',
  },
  tabs: {
    general: 'General',
    pickup: 'Recogida',
    delivery: 'Entrega a domicilio',
    room_service: 'Servicio de habitación/mesa',
  },
  modals: {
    update_confirmation: {
      title: '¿Estás seguro de que quieres guardar los nuevos cambios?',
      buttons: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
      },
    },
    switch_live_orders: {
      titles: {
        disable: '¿Estás seguro de que quieres desactivar los pedidos en vivo?',
        enable: '¿Estás seguro de que quieres activar los pedidos en vivo?',
      },
      buttons: {
        yes: 'Sí',
        no: 'No',
      },
    },
  },
  toasts: {
    failed_to_save_changes: 'Error al guardar los cambios',
    changes_got_saved: 'Cambios guardados',
  },
};
